import {
  CLEAR_CONFIG_MODAL_ERRORS,
  CLEAR_TOAST,
  CLOSE_CONFIG_MODAL,
  OPEN_CONFIG_MODAL,
  SET_ACTIVE_TAB,
  SET_GLOSSARY_OPEN,
  SHOW_TOAST,
  SUBMIT_CONFIG_MODAL,
  SUBMIT_CONFIG_MODAL_FAILURE,
} from "../types";

export type CoilTab = "configurations" | "catalogue" | "assumptions" | "measured-data";
export type ConfigModalMode = "create" | "edit";

export interface ConfigModalState {
  open: boolean;
  mode: ConfigModalMode;
  editId: string | null;
  fieldErrors: Record<string, string>;
  formError: string | null;
  submitting: boolean;
}

export interface UiState {
  activeTab: CoilTab;
  glossaryOpen: boolean;
  toast: { message: string; type: "success" | "error" } | null;
  configModal: ConfigModalState;
}

const initialConfigModal: ConfigModalState = {
  open: false,
  mode: "create",
  editId: null,
  fieldErrors: {},
  formError: null,
  submitting: false,
};

const initialState: UiState = {
  activeTab: "configurations",
  glossaryOpen: false,
  toast: null,
  configModal: initialConfigModal,
};

type UiAction =
  | { type: typeof SET_ACTIVE_TAB; tab: CoilTab }
  | { type: typeof SET_GLOSSARY_OPEN; open: boolean }
  | { type: typeof SHOW_TOAST; message: string; toastType: "success" | "error" }
  | { type: typeof CLEAR_TOAST }
  | { type: typeof OPEN_CONFIG_MODAL; mode: ConfigModalMode; editId: string | null }
  | { type: typeof CLOSE_CONFIG_MODAL }
  | { type: typeof SUBMIT_CONFIG_MODAL }
  | { type: typeof SUBMIT_CONFIG_MODAL_FAILURE; fieldErrors?: Record<string, string>; formError?: string }
  | { type: typeof CLEAR_CONFIG_MODAL_ERRORS };

const uiReducer = (state = initialState, action: UiAction): UiState => {
  switch (action.type) {
    case SET_ACTIVE_TAB:
      return { ...state, activeTab: action.tab };
    case SET_GLOSSARY_OPEN:
      return { ...state, glossaryOpen: action.open };
    case SHOW_TOAST:
      return { ...state, toast: { message: action.message, type: action.toastType } };
    case CLEAR_TOAST:
      return { ...state, toast: null };
    case OPEN_CONFIG_MODAL:
      return {
        ...state,
        configModal: {
          open: true,
          mode: action.mode,
          editId: action.editId,
          fieldErrors: {},
          formError: null,
          submitting: false,
        },
      };
    case CLOSE_CONFIG_MODAL:
      return {
        ...state,
        configModal: initialConfigModal,
      };
    case SUBMIT_CONFIG_MODAL:
      return {
        ...state,
        configModal: {
          ...state.configModal,
          submitting: true,
          formError: null,
        },
      };
    case SUBMIT_CONFIG_MODAL_FAILURE:
      return {
        ...state,
        configModal: {
          ...state.configModal,
          submitting: false,
          fieldErrors: action.fieldErrors ?? {},
          formError: action.formError ?? null,
        },
      };
    case CLEAR_CONFIG_MODAL_ERRORS:
      return {
        ...state,
        configModal: {
          ...state.configModal,
          fieldErrors: {},
          formError: null,
        },
      };
    default:
      return state;
  }
};

export default uiReducer;
